export default __webpack_public_path__ + "static/media/2_MonstaVerse.57dc3372.webp";